var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6898 12.9267V14C25.6883 16.5158 24.8737 18.9638 23.3673 20.9788C21.861 22.9938 19.7436 24.4679 17.331 25.1812C14.9184 25.8945 12.3399 25.8089 9.97999 24.937C7.62007 24.0652 5.60521 22.4538 4.2359 20.3433C2.86659 18.2327 2.2162 15.7361 2.38173 13.2257C2.54727 10.7153 3.51985 8.32572 5.15444 6.41326C6.78902 4.50079 8.99803 3.16795 11.452 2.61351C13.906 2.05907 16.4734 2.31273 18.7715 3.33667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6901 4.66675L14.0234 16.3451L10.5234 12.8451",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.cc8d570a3609727e4b20be9fc3a4d836.svg";
export { ForwardRef as ReactComponent };